import { Component, HostBinding, Input, OnInit } from "@angular/core"
import { ErrorCode } from "../error-code.model"
import { CHNode } from "../../models/node.model"
import { LearningObject } from "../../models/learningObject.model"
import { UserService } from "../../services/user.service"
import { STATIC_IMAGES } from "../../models/constants"
import { AddOnViewService } from "../../services/add-on-view.service"

@Component({
    selector: "app-unauthorized-error",
    templateUrl: "./unauthorized-error.component.html",
    styleUrls: ["./unauthorized-error.component.scss"],
})
export class UnauthorizedErrorComponent implements OnInit {
    @HostBinding("style") hostBinding = "flex: 1"
    @Input() nextURL: string
    @Input() errorCode: ErrorCode
    @Input() errorMessage: string
    @Input() showContent: boolean = false
    @Input() subjects: CHNode[] = []
    @Input() learningObjects: LearningObject[] = []

    image: string
    ErrorCode = ErrorCode
    isStudent: boolean
    isAddonView: boolean

    constructor(private userService: UserService, private addOnViewService: AddOnViewService) {}

    ngOnInit(): void {
        this.isAddonView = this.addOnViewService.isAddonView
        this.image = STATIC_IMAGES.lost_in_space
        this.isStudent = this.userService.hasStudentExperience()
    }
}
